// ---------------------------------------------------------
// Email Validation
// ---------------------------------------------------------

export function validateBusinessEmail(email = "") {
  const trimmed = email.trim().toLowerCase();

  // Basic RFC regex
  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const isValidFormat = emailRegex.test(trimmed);

  // Free email providers
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "icloud.com",
    "live.com",
    "aol.com"
  ];

  const domain = trimmed.split("@")[1] || "";
  const isFreeDomain = freeDomains.includes(domain);

  return {
    ok: isValidFormat && !isFreeDomain,
    isValidFormat,
    isFreeDomain,
    domain,
  };
}


// ---------------------------------------------------------
// Password Validation
// ---------------------------------------------------------

export function validatePassword(password = "") {
  if (!password) return { ok: false, reason: "Password required" };

  if (password.length < 6)
    return { ok: false, reason: "Password too short (min 6 chars)" };

  // Optional: require at least one number
  const hasNum = /\d/.test(password);

  return {
    ok: hasNum,
    reason: hasNum ? null : "Add at least one number",
  };
}


// ---------------------------------------------------------
// Company Domain Validation (Register Company form)
// ---------------------------------------------------------

export function validateCompanyDomain(domain = "") {
  const trimmed = domain.trim().toLowerCase();

  // allow abc.com, kwery.ai, company.co.uk etc.
  const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const ok = domainRegex.test(trimmed);

  return {
    ok,
    reason: ok ? null : "Invalid domain format",
  };
}

